


export function initSeminarNav(){
    const navElementWrapper=document.querySelector('.jumpmark-nav-wrapper');
    if(!navElementWrapper) return;
    const navElement=navElementWrapper.querySelector('nav');
    if(!navElement) return;
    const headerElement=document.querySelector('.header-container');
    if(!headerElement) return;

    const navItems=navElement.querySelectorAll('li');
    const additionsScrollButtons=document.querySelectorAll('.scroll-button');

    const addScrollFunction=(navItems)=>{
        for(let navItem of navItems){
            navItem.addEventListener('click', (e)=>{
                e.preventDefault();
                const target=navItem.dataset.target;
                const section=document.querySelector(target);
                if(!section) return;

                const offset=navElement.getBoundingClientRect().height || 0;

                window.scrollTo({top: section.offsetTop - offset, behavior: 'smooth'});
            })
        }

    }

    addScrollFunction(navItems)

    addScrollFunction(additionsScrollButtons)


    const pageSections=document.querySelectorAll('.section-in-nav');

    const handleSeminarNav=()=>{
        const headerHeight=headerElement.getBoundingClientRect().height;
        const adjustedDistance = window.pageYOffset + headerHeight;
        const navHeight=navElement.getBoundingClientRect().height;
        navElementWrapper.style.height=`${navHeight}px`;

        const navDistanceToTop=navElementWrapper.getBoundingClientRect().top + document.documentElement.scrollTop


        if(adjustedDistance>=navDistanceToTop){
            navElement.style.top=`${headerHeight}px`;
            navElement.classList.add('sticky');

        }else{
            navElement.classList.remove('sticky');
            navElement.style.top='unset';
        }


        let firstSectionInViewport;
        const offset=headerHeight+navHeight;

        for(let section of pageSections){
            if(elementInViewport(section, offset)){
                firstSectionInViewport=section;
                break;
            }
        }

        if(firstSectionInViewport){
            let sectionId=firstSectionInViewport.id || '';
            sectionId=`#${sectionId}`;

            for(let navItem of navItems){
                navItem.classList.remove('active');
                const targetId=navItem.dataset.target;
                if(targetId===sectionId){
                    navItem.classList.add('active');
                }
            }
        }else{
            for(let navItem of navItems){
                navItem.classList.remove('active');
            }
        }

    }

    window.addEventListener('scroll', handleSeminarNav)
    window.addEventListener('resize', handleSeminarNav)
    window.addEventListener('orientationchange', handleSeminarNav)

    const navItemsList=navElement.querySelector('ul');
    if(!navItemsList) return;

    const handleNavWidth=()=>{
        const totalWidth=navItemsList.scrollWidth || 0;
        const visibleWidth=navItemsList.clientWidth || 0
        totalWidth>visibleWidth ? navElement.classList.add('has-overflow') : navElement.classList.remove('has-overflow');
    }

    handleNavWidth();
    window.addEventListener('resize', handleNavWidth)
    window.addEventListener('orientationchange', handleNavWidth)

    const nextButton=navElement.querySelector('.next')
    const prevButton=navElement.querySelector('.prev')

    const scrollStep=120;

    nextButton?.addEventListener('click', ()=>{
        navItemsList.scrollTo({top: 0, left: navItemsList.scrollLeft+scrollStep, behavior: 'smooth'})
    })

    prevButton?.addEventListener('click', ()=>{
        navItemsList.scrollTo({top: 0, left: navItemsList.scrollLeft-scrollStep, behavior: 'smooth'})
    })

    const sudRoots = document.querySelectorAll('[data-sud="root"]');
    if (sudRoots.length > 0) {
        const sudAccess = !!document.querySelector('.data-sud-granted');

        for (let sudRoot of sudRoots) {
            if (sudAccess) sudRoot.classList.add('sud-granted');
            else sudRoot.classList.remove('sud-granted');
        }
    }
}

function elementInViewport (el, offset=0) {
    let top = el.offsetTop;
    let left = el.offsetLeft;
    let width = el.offsetWidth;
    let height = el.offsetHeight;

    while(el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    const adjustedPageYOffset=window.pageYOffset+offset;

    return (
        top < (adjustedPageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > adjustedPageYOffset &&
        (left + width) > window.pageXOffset
    );
}


initSeminarNav();
